import React from 'react';
import styles from './MessagesTab.module.css';

const MessagesTab = ({ messages, onViewMessage, onSendReply, selectedMessage, replyText, setReplyText, sendingReply, showMessageModal, closeMessageModal, tabId = "messages", tabLabel = "Messages" }) => {

  return (
    <div
      tabId={tabId}
      tabLabel={tabLabel}
      className={styles.messagesContainer}
    >
      <div className={styles.messagesWrapper}>
        <h4 className={styles.messagesTitle}>
          Messages from Teachers
        </h4>

        {messages.length === 0 ? (
          <aside className={styles.emptyState}>
            📭 No messages from your teacher yet. Check back later!
          </aside>
        ) : (
          <aside className={styles.inboxContainer}>
            {/* INBOX HEADER */}
            <div className={styles.inboxHeader}>
              <div className={styles.headerRow}>
                <div className={`${styles.headerColumn} ${styles.headerColumnFrom}`}>From</div>
                <div className={`${styles.headerColumn} ${styles.headerColumnSubject}`}>Subject</div>
                <div className={`${styles.headerColumn} ${styles.headerColumnDate}`}>Date</div>
              </div>
            </div>

            {messages.map((message) => (
              <header
                key={message._id}
                onClick={() => onViewMessage(message)}
                className={`${styles.messageItem} ${selectedMessage?._id === message._id ? styles.messageItemSelected : ''}`}
              >
                <div className={styles.messageRow}>
                  <div className={`${styles.messageColumn} ${styles.messageColumnFrom}`}>
                    {message.teacherName || 'Your Teacher'}
                  </div>
                  <div className={`${styles.messageColumn} ${styles.messageColumnSubject}`}>
                    Message from Teacher
                  </div>
                  <div className={`${styles.messageColumn} ${styles.messageColumnDate}`}>
                    {new Date(message.createdAt).toLocaleDateString()}
                  </div>
                </div>

                {message.reply && (
                  <div className={styles.replyBadge}>
                    <span className={styles.replyBadgeText}>
                      ✅ Replied
                    </span>
                  </div>
                )}
                {!message.reply && (
                  <div className={styles.unreadBadge}>
                    <span className={styles.unreadBadgeText}>
                      📬 Unread
                    </span>
                  </div>
                )}
              </header>
            ))}
          </aside>
        )}

        {/* Message Modal */}
        {showMessageModal && selectedMessage && (
          <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
              <div className={styles.modalHeader}>
                <h5 className={styles.modalTitle}>
                  Message from {selectedMessage.teacherName || 'Your Teacher'}
                </h5>
                <button
                  onClick={closeMessageModal}
                  className={styles.closeButton}
                >
                  ×
                </button>
              </div>

              <div className={styles.modalBody}>
                <p className={styles.modalMessage}>
                  {selectedMessage.message}
                </p>
              </div>

              {selectedMessage.reply && (
                <div className={styles.replySection}>
                  <h6 className={styles.replyTitle}>
                    Your Reply:
                  </h6>
                  <p className={styles.replyText}>
                    {selectedMessage.reply}
                  </p>
                </div>
              )}

              {!selectedMessage.reply && (
                <div>
                  <textarea
                    value={replyText}
                    onChange={(e) => setReplyText(e.target.value)}
                    placeholder="Type your reply..."
                    className={styles.replyForm}
                  />
                  <div className={styles.replyActions}>
                    <button
                      onClick={() => onSendReply(selectedMessage._id)}
                      disabled={sendingReply || !replyText.trim()}
                      className={styles.replyButton}
                    >
                      {sendingReply ? 'Sending...' : 'Send Reply'}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MessagesTab; 